import { UseFormWatch, UseFormSetValue } from 'react-hook-form'
import { SectorFormData } from '../schemas/sectorSchema'

interface UseSectorDrawerContentProps {
    watch: UseFormWatch<SectorFormData>
    setValue: UseFormSetValue<SectorFormData>
    handleStatusChange: (newStatus: string) => void
}

export const useSectorDrawerContent = ({
    watch,
    setValue,
    handleStatusChange
}: UseSectorDrawerContentProps) => {
    const nameValue = watch('name')
    const statusValue = watch('status')

    const handleNameChange = (value: string) => {
        setValue('name', value, { shouldDirty: true, shouldValidate: true })
    }

    const handleStatusToggle = () => {
        const newStatus = statusValue !== 'true' ? 'true' : 'false'
        handleStatusChange(newStatus)
    }

    return {
        nameValue,
        statusValue,
        handleNameChange,
        handleStatusChange: handleStatusToggle
    }
}
